module.exports = __webpack_public_path__ + "c6bf310312bf89be7633326158481b22.MP3";